// extracted by mini-css-extract-plugin
export default {"container":"contract-settings-table_container__3YuF0"};